import { useEffect, useState } from "react";
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import "./ExactDateSelector.css";

const ExactDateSelector = ({ selectedDate, setSelectedDate, minDate, maxDate, label = "Select Date", autoOpen = false }) => {
  const [open, setOpen] = useState(autoOpen);
  // NEW: local "pending" value so the mobile dialog's Cancel button can discard an
  // in-progress selection — previously onChange committed to selectedDate on every
  // tap, so by the time Cancel was pressed the date was already applied/dialog closed.
  const [pendingDate, setPendingDate] = useState(selectedDate);

  useEffect(() => {
    if (selectedDate) setOpen(false);
  }, [selectedDate]);

  useEffect(() => {
    setPendingDate(selectedDate);
  }, [selectedDate]);

  const handleClear = (e) => {
    e.stopPropagation();
    setSelectedDate(null);
  };

  return (
    <div
      className="exactDateSelectBox exactDateSelect"
      // style={{ position: "relative", cursor: "pointer" }} — moved to style.css .exactDateSelectBox
      // OLD: onClick={() => setOpen(true)} — this ancestor div's onClick fires on every
      // click that bubbles through the React tree, including the mobile dialog's Cancel
      // button (rendered via portal, but still a React descendant here), reopening the
      // dialog in the same event that just closed it via onClose.
      onClick={() => { if (!open) setOpen(true); }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          className="memberDropDown"
          open={open}
          onOpen={() => setOpen(true)}
          // OLD: onClose={() => setOpen(false)}
          onClose={() => {
            setOpen(false);
            setPendingDate(selectedDate);
          }}
          label={label}
          format="DD-MM-YYYY"
          // OLD: value={selectedDate}
          // OLD: onChange={(date) => { setSelectedDate(date); setOpen(false); }}
          value={pendingDate}
          onChange={(date) => setPendingDate(date)}
          onAccept={(date) => { setSelectedDate(date); setOpen(false); }}
          {...(dayjs.isDayjs(minDate) ? { minDate } : {})}
          {...(dayjs.isDayjs(maxDate) ? { maxDate } : {})}
          slotProps={{
            textField: {
              className: `yearlyDatePicker ${selectedDate ? "bg-white" : ""}`,
              placeholder: label,
              size: "small",
              onClick: (e) => { e.stopPropagation(); setOpen(true); },
              sx: {
                width: "100%",
                "& .MuiFormLabel-root": {
                  fontSize: "14px",
                  fontFamily: "Graphik Medium",
                  color: "#9A9B9B",
                  lineHeight: "22px",
                  paddingTop: 0,
                },
                // Match FloatingDropdownWithArrow text position (padding 12px 14px in 55px field)
                "& .MuiFormLabel-root:not(.MuiInputLabel-shrink)": {
                  transform: "translate(14px, 16px) scale(1)",
                },
                "& .MuiFormLabel-root.MuiInputLabel-shrink": {
                  paddingTop: 0,
                  transform: "translate(14px, -9px) scale(0.75)",
                },
                "& .MuiFormLabel-root.Mui-focused": {
                  color: "#9A9B9B",
                },
                "& .MuiOutlinedInput-notchedOutline legend": {
                  lineHeight: "11px",
                  fontSize: "9.75px",
                },
                "& .MuiOutlinedInput-root": {
                  minHeight: "55px",
                  height: "55px",
                  boxSizing: "border-box",
                  fontSize: "14px",
                  lineHeight: "22px",
                  color: selectedDate ? "#06152b" : "#9A9B9B",
                  fontFamily: "Graphik Medium",
                  borderRadius: "12px",
                  backgroundColor: selectedDate ? "#ffffff" : "#f7f7f7",
                  paddingTop: 0,
                  paddingBottom: 0,
                  paddingLeft: "14px",
                  paddingRight: selectedDate ? "40px" : "14px",
                  alignItems: "center",
                  width: "100%",
                  "& fieldset": {
                    borderColor: selectedDate ? "#11B700" : "transparent",
                    borderWidth: "2px",
                    borderRadius: "12px",
                  },
                  "&:hover": {
                    backgroundColor: "#ffffff",
                  },
                  "&:hover fieldset": {
                    borderColor: "#11B700",
                    borderWidth: "2px",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#11B700",
                    borderWidth: "2px",
                  },
                },
                "& .MuiOutlinedInput-input": {
                  padding: "12px 0",
                  height: "auto",
                  boxSizing: "border-box",
                  fontSize: "14px",
                  lineHeight: "22px",
                  fontFamily: "Graphik Medium",
                  color: selectedDate ? "#06152b" : "#9A9B9B",
                },
                "& .MuiPickersSectionList-root, & .MuiPickersInputBase-sectionsContainer":
                  {
                    padding: "12px 0",
                    boxSizing: "border-box",
                    fontSize: "14px",
                    lineHeight: "22px",
                    fontFamily: "Graphik Medium",
                    color: selectedDate ? "#06152b" : "#9A9B9B",
                  },
                "& .MuiInputAdornment-root": {
                  marginLeft: 0,
                  height: "100%",
                  maxHeight: "none",
                },
              },
            },
          }}
          slots={{ openPickerIcon: ArrowDropDownIcon }}
        />
      </LocalizationProvider>
      {selectedDate && (
        <IconButton
          onClick={handleClear}
          size="small"
          sx={{
            backgroundColor: "#fff",
            position: "absolute",
            right: "4px",
            top: "50%",
            transform: "translateY(-50%)",
            padding: "10px",
            zIndex: 1,
            "&:hover": { backgroundColor: "#f1f1f1" },
          }}
        >
          <CloseIcon sx={{ fontSize: "18px", color: "#9A9B9B" }} />
        </IconButton>
      )}
    </div>
  );
};

export default ExactDateSelector;

/* OLD IMPLEMENTATION — commented out, keeping for reference
const ExactDateSelectorOld = ({ selectedDate, setSelectedDate, minDate, maxDate, label = "Select Date" }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (selectedDate) setOpen(false);
  }, [selectedDate]);

  const handleClear = (e) => {
    e.stopPropagation();
    setSelectedDate(null);
  };

  return (
    <div
      className="exactDateSelectBox exactDateSelect"
      // style={{ position: "relative", cursor: "pointer" }} — moved to style.css .exactDateSelectBox
      onClick={() => setOpen(true)}
    >
      // OLD APPROACH: Custom span overlay — covered by MUI input background in some CSS contexts
      // {!selectedDate && (
      //   <span style={{
      //     position: "absolute", left: "14px", top: "50%", transform: "translateY(-50%)",
      //     color: "#9A9B9B", fontSize: "14px", fontFamily: "Graphik Medium",
      //     pointerEvents: "none", zIndex: 1, whiteSpace: "nowrap",
      //   }}>
      //     {label}
      //   </span>
      // )}
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          className="memberDropDown"
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          format="DD-MM-YYYY"
          label={label}
          value={selectedDate}
          onChange={(date) => { setSelectedDate(date); setOpen(false); }}
          {...(dayjs.isDayjs(minDate) ? { minDate } : {})}
          {...(dayjs.isDayjs(maxDate) ? { maxDate } : {})}
          slotProps={{
            textField: {
              className: `yearlyDatePicker ${selectedDate ? "bg-white" : ""}`,
              size: "small",
              placeholder: label,
              onClick: (e) => { e.stopPropagation(); setOpen(true); },
              inputProps: {
                readOnly: true,
                style: {
                  caretColor: "transparent",
                  cursor: "pointer",
                  userSelect: "none",
                  WebkitUserSelect: "none",
                  MozUserSelect: "none",
                  msUserSelect: "none",
                },
                onFocus: (e) => {
                  e.target.setSelectionRange(0, 0);
                  setTimeout(() => { e.target.blur(); setOpen(true); }, 0);
                },
              },
              sx: {
                width: "100%",
                "& .MuiOutlinedInput-root": {
                  minHeight: "55px",
                  fontSize: "14px",
                  fontFamily: "Graphik Medium",
                  color: selectedDate ? "rgba(0,0,0,0.87)" : "#9A9B9B",
                  backgroundColor: selectedDate ? "#ffffff" : "#f7f7f7",
                  borderRadius: "12px",
                  paddingLeft: "14px",
                  paddingRight: selectedDate ? "40px" : "14px",
                  cursor: "pointer",
                  userSelect: "none",
                  "& fieldset": {
                    borderColor: selectedDate ? "#11B700" : "transparent",
                    borderWidth: "2px",
                    borderRadius: "12px",
                  },
                  "&:hover": { backgroundColor: "#ffffff" },
                  "&:hover fieldset": { borderColor: "#11B700", borderTopWidth: "2px !important" },
                  "&.Mui-focused fieldset": { borderColor: "#11B700", borderWidth: "2px", borderTopWidth: "2px !important" },
                },
                "& .MuiOutlinedInput-input": { paddingTop: 0, paddingBottom: 0, cursor: "pointer", userSelect: "none" },
                "& .MuiInputLabel-root": { display: selectedDate ? "none" : "block", fontFamily: "Graphik Medium", color: "#9A9B9B" },
                "& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": { fontSize: "14px", top: "8px" },
                "& .MuiSvgIcon-root": { cursor: "pointer" },
              },
            },
          }}
          slots={{ openPickerIcon: ArrowDropDownIcon }}
        />
      </LocalizationProvider>
      {selectedDate && (
        <IconButton onClick={handleClear} size="small" sx={{ position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)", padding: "4px", zIndex: 1, "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" } }}>
          <CloseIcon sx={{ fontSize: "18px", color: "#9A9B9B" }} />
        </IconButton>
      )}
    </div>
  );
};
*/
